<template>
  <div class="l-row">
    <form-group label="Tipo do módulo" :required="true">
      <select v-model="expediter.type" class="form-select" @change="onChangeExpediterType">
        <option :value=null>Selecione</option>
        <option v-for="expediter in expediters" :key="expediter" :value="expediter.type">{{ $t(expediter.type).label }}</option>
      </select>
      <small class="form-help">Define com qual tipo de sistema os pedidos do marketplace devem ser sincronizados.</small>
    </form-group>

    <form-group label="Nome do módulo" v-if="expediter.type && expediter.type !== 'null'" :required="isRequired">
      <select v-model="expediter.identifier" class="form-select">
        <option :value=null>Selecione</option>
        <option v-for="expediterIdentifier in identifiers" :key="expediterIdentifier" :value="expediterIdentifier">{{ $t(expediterIdentifier).label }}</option>
      </select>
      <small class="form-help">Define com qual sistema os pedidos do marketplace devem ser sincronizados.</small>
    </form-group>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    inject: ['expeditersDI'],
    data: () => ({
      identifiers: [],
      expediters: []
    }),
    props: {
      expediter: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.expediters = this.expeditersDI.map(expediterDI => {
        if (this.definitionModulesInstalled.find(module => module.type === expediterDI.type && expediterDI.identifiers.indexOf(module.identifier) !== -1)) {
          expediterDI.identifiers = expediterDI.identifiers.filter(identifierDI => this.definitionModulesInstalled.find(module => module.type === expediterDI.type && module.identifier === identifierDI))

          return expediterDI
        }
      })
        .filter(expediterDI => expediterDI !== undefined)
    },
    methods: {
      onChangeExpediterType () {
        if (!this.expediter.type) {
          this.expediter.type = null
        }

        this.expediter.identifier = null
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionModulesInstalled'
      ]),
      isRequired () {
        return !!this.expediter.type
      }
    },
    components: {
      FormGroup
    },
    watch: {
      'expediter.type' (value) {
        if (value) {
          this.identifiers = (this.expediters.find(expediter => expediter.type === value)).identifiers
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ExpediterConfiguration.vue?7ba3e5ac